import classnames from 'classnames/bind'
import { useEffect, useRef, useState } from 'react'
import { useInterval } from 'react-use'
import { IconUspSliderItem } from '~/@types/cart'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { useMeasureObserver } from '@unlikelystudio/react-hooks'
import Slider, { useSliderState } from '@unlikelystudio/react-slider'

import SliderControls from '~/components/Abstracts/SliderControls'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)
export interface UspSliderProps {
  className?: string
  layout?: 'cart' | 'product-page'
  items: IconUspSliderItem[]
}

export function UspSlider({
  className,
  layout = 'cart',
  items,
}: UspSliderProps) {
  const sliderItemStyle = useStyle({
    textPreset: GlobalTextPreset.Text10Secondary,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Gray1ToBlack,
  })

  const customSliderRef = useRef(null)
  const sliderBounds = useMeasureObserver(
    customSliderRef,
    'getBoundingClientRect',
  )
  const [intervalTime, setIntervalTime] = useState(null)

  const [{ slideIndex, nextSlide, prevSlide, setSlideIndex }, setSliderState] =
    useSliderState()

  const autoIncrementValues = () => {
    const maxValue = items?.length - 1
    let newCurrent = null
    if (slideIndex < maxValue && slideIndex >= 0) {
      newCurrent = slideIndex + 1
    } else {
      newCurrent = 0
    }

    setSlideIndex(newCurrent)
  }

  useInterval(autoIncrementValues, intervalTime)

  useEffect(() => {
    if (items?.length <= 1) {
      setIntervalTime(null)
    } else {
      // setIntervalTime(INTERVAL)
    }
  }, [items])

  return (
    <div className={cx(css.UspSlider, className, css?.[`layout-${layout}`])}>
      <div className={cx(css.sliderWrapper)} ref={customSliderRef}>
        <Slider
          className={cx(css.slider)}
          customSliderRef={customSliderRef}
          autoIsSlider={true}
          snap
          setSliderState={setSliderState}>
          {items?.map((item, index) => (
            <div
              key={`slider_item_${layout}_${index}`}
              className={cx(css.sliderItemWrapper)}
              style={{
                width: `${sliderBounds?.width ?? 0}px`,
              }}>
              {item?.icon?.src && (
                <span className={css.iconContainer}>
                  <span
                    style={{ backgroundImage: `url(${item?.icon?.src})` }}
                    className={css.icon}
                  />
                </span>
              )}

              <span className={cx(css.itemText, sliderItemStyle)}>
                {item?.text}
              </span>
            </div>
          ))}
        </Slider>

        <SliderControls
          length={items?.length}
          className={css.sliderControlsItem}
          buttonClassName={css.sliderButton}
          activeClassName={css.activeSliderButton}
          slideIndex={slideIndex}
          setSlideIndex={setSlideIndex}
        />
      </div>
    </div>
  )
}
